// @flow
import * as actionTypes from '../../actionTypes/searchTypes'
const {
  SELECT_VALUE,
  SELECTED_HAS_RELATED,
  DESELECT_VALUE,
  CHANGE_SEARCH_VALUE,
  FILTER_SUGGESTIONS
} = actionTypes

export const initialState = {
  selected: null,
  searchValue: '',
  list: []
}

export default function searchReducer(
  state: Object = initialState,
  action: Object
): Object {
  switch (action.type) {
    case SELECT_VALUE:
      return {
        ...state,
        selected: {
          ...action.selected,
          hasRelated: null
        }
      }
    case SELECTED_HAS_RELATED:
      return {
        ...state,
        selected: {
          ...state.selected,
          hasRelated: action.hasRelated
        }
      }
    case DESELECT_VALUE:
      return {
        ...state,
        selected: null,
        searchValue: '',
        list: []
      }
    case CHANGE_SEARCH_VALUE:
      return {
        ...state,
        searchValue: action.searchValue
      }
    case FILTER_SUGGESTIONS:
      return {
        ...state,
        list: action.list
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/shared/reducers/search/search.js